/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [批量激活分账↗](http://yapi.yishou.com/project/128/interface/api/33600) 的 **请求配置**
 *
 * @分类 [返回资金流水↗](http://yapi.yishou.com/project/128/interface/api/cat_3182)
 * @请求头 `POST /erp/RefundBill/batchActivation`
 * @更新时间 `2022-05-30 15:19:45`
 */
const batchActivationRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/RefundBill/batchActivation",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        title: "empty object",
        properties: {
            srb_ids: { type: "array", items: { type: "string" }, description: "返货单id数组" },
            statistic: { type: "number", description: "是否统计" },
        },
        required: ["srb_ids", "statistic"],
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            num: { type: "string", description: "开启统计后，返回总数" },
            totalAmount: { type: "string", description: "开启统计后，返回总金额" },
        },
    },
    requestFunctionName: "batchActivation",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [批量激活分账↗](http://yapi.yishou.com/project/128/interface/api/33600) 的 **请求函数**
 *
 * @分类 [返回资金流水↗](http://yapi.yishou.com/project/128/interface/api/cat_3182)
 * @请求头 `POST /erp/RefundBill/batchActivation`
 * @更新时间 `2022-05-30 15:19:45`
 */
export const batchActivation = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(batchActivationRequestConfig, requestData), ...args);
};
batchActivation.requestConfig = batchActivationRequestConfig;
/**
 * 接口 [日志列表↗](http://yapi.yishou.com/project/128/interface/api/33601) 的 **请求配置**
 *
 * @分类 [返回资金流水↗](http://yapi.yishou.com/project/128/interface/api/cat_3182)
 * @请求头 `POST /erp/RefundBill/logList`
 * @更新时间 `2022-05-25 20:29:45`
 */
const logListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/RefundBill/logList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["srb_id"],
        properties: { srb_id: { type: "string", description: "返回单id" } },
    },
    responseDataJsonSchema: {
        type: "array",
        items: {
            type: "object",
            properties: {
                admin: { type: "string", description: "操作人" },
                operate_mode: { type: "string", description: "操作方式" },
                operate_result: { type: "string", description: "操作结果" },
                created_at: { type: "string", description: "操作时间" },
                remark: { type: "string", description: "备注" },
            },
            required: ["admin", "operate_mode", "operate_result", "created_at", "remark"],
        },
    },
    requestFunctionName: "logList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [日志列表↗](http://yapi.yishou.com/project/128/interface/api/33601) 的 **请求函数**
 *
 * @分类 [返回资金流水↗](http://yapi.yishou.com/project/128/interface/api/cat_3182)
 * @请求头 `POST /erp/RefundBill/logList`
 * @更新时间 `2022-05-25 20:29:45`
 */
export const logList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(logListRequestConfig, requestData), ...args);
};
logList.requestConfig = logListRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/refundBill.js